// Port of api/fuel/app/classes/filter/package/games/game/prepare/context/plays.php
export default {
	run: function(local, global) {
		if (!global.context || !global.context.plays) return local
		local.context = local.context || {}
		local.context.plays = { total: 0, duration: 0, last: 0, users: {}, user: { total: 0, duration: 0, last: 0, first: 0 } }
		var ctxPlays = global.context.plays.data ? global.context.plays.data[local.game_id] : null
		if (!ctxPlays) return local
		var keys = Object.keys(ctxPlays)
		for (var i = 0; i < keys.length; i++) {
			var p = ctxPlays[keys[i]]
			local.context.plays.total += parseInt(p.total_plays || 0)
			local.context.plays.duration += parseInt(p.total_duration || 0)
			if (p.last_play > local.context.plays.last) local.context.plays.last = p.last_play
			local.context.plays.users[keys[i]] = parseInt(p.total_plays || 0)
		}
		if (global.userID && ctxPlays[global.userID]) {
			var up = ctxPlays[global.userID]
			local.context.plays.user = { total: parseInt(up.total_plays || 0), duration: parseInt(up.total_duration || 0), last: up.last_play || 0, first: up.first_play || 0 }
		}
		return local
	}
}
